module.exports = __webpack_public_path__ + "static/media/onboarding-cec.6ec337fd.png";